class CustomTabs extends HTMLElement {
  constructor() {
    super();

    this.$container = $(this);
  }

  get selectors() {
    return {
      control: "custom-tabs-control",
      content: "custom-tabs-content"
    }
  }

  get attributes() {
    return {
      index: "index"
    }
  }

  get modifiers() {
    return {
      active: "active"
    }
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const self = this;

    this.$container.on("click", this.selectors.control, function () {
      self.activateTab($(this));
    });

    this.$container.on("keydown", this.selectors.control, function (event) {
      const $controls = $(self.selectors.control, self.$container);
      const currentIndex = $controls.index(this);

      switch (event.key) {
        case "Enter":
        case " ": {
          $(this).trigger("click");
          event.preventDefault();
          break;
        }

        case "ArrowRight":
        case "ArrowDown": {
          const nextIndex = currentIndex + 1 < $controls.length ? currentIndex + 1 : 0;
          $controls.eq(nextIndex).trigger("focus").trigger("click");
          event.preventDefault();
          break;
        }

        case "ArrowLeft":
        case "ArrowUp": {
          const previousIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : $controls.length - 1;
          $controls.eq(previousIndex).trigger("focus").trigger("click");
          event.preventDefault();
          break;
        }
      }
    });
  }

  activateTab($currentControl) {
    const self = this;

    if ($currentControl.hasClass(self.modifiers.active)) {
      return false;
    }

    let currentIndex = $currentControl.attr(self.attributes.index);

    let $currentContent = $(`${self.selectors.content}[index=${currentIndex}]`, self.$container);

    let $allControls = $(self.selectors.control, self.$container);
    let $allContent = $(self.selectors.content, self.$container);

    $allControls.removeClass(self.modifiers.active).attr({
      "aria-selected": "false",
      tabindex: "-1"
    });
    $allContent.removeClass(self.modifiers.active);

    $currentControl.addClass(self.modifiers.active).attr({
      "aria-selected": "true",
      tabindex: "0"
    });
    $currentContent.addClass(self.modifiers.active);
  }

  switchTabByHandle(handle) {
    const self = this;

    if (!handle) {
      return false;
    }

    let $tabControl = $(`${self.selectors.control}[handle=${handle}]`, self.$container);

    if (!$tabControl) {
      return false;
    }

    $tabControl.trigger("click");
  }
}

if (!customElements.get("custom-tabs")) {
  customElements.define("custom-tabs", CustomTabs);
}
